import countriesDropdownValues from "../Utils/CountriesUN";
import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";

interface LocationProps {
  errors: string[];
  isCBE: boolean;
  data: {
    country: string;
    address: string;
    city: string;
    zipCode: string;
  };
  status: number;
  handleOnChangeLocation: (e: React.ChangeEvent<any>) => void;
  handleDeleteLocation: () => void;
}
function LocationComponent({
  errors,
  data,
  status,
  handleOnChangeLocation,
  handleDeleteLocation,
}: LocationProps) {
  const [isHidden, setIsHidden] = useState(false);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteLocation();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="feedstock-container">
      <CardHeader
        isHidden={isHidden}
        toggleVisibility={toggleVisibility}
        cardName="Location"
        handleDelete={status == 1 ? handleDeleteClick : null}
        notValid={errors.length > 0}
        subTitle="Please include the location of the demonstration or flagship plant (relevant for IA projects only)."
      />
      <>
        {isHidden ? null : (
          <div className="form-container">
            <div className="error-container">
              {errors.map((error, index) => (
                <div
                  className="error-text"
                  key={index}
                  style={{ marginBottom: "10px" }}
                >
                  {error}
                </div>
              ))}
            </div>
            <div className="question-group-input-first">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <DropdownStringMandatory
                    listInputs={countriesDropdownValues.map(
                      (country) => country.name
                    )}
                    label={"Country"}
                    inputName={"country"}
                    value={data.country}
                    handleOnChange={handleOnChangeLocation}
                    invalidValues={["", "-"]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextNoConfidential
                    label={"Address"}
                    textValid={data.address.length > 4}
                    textValue={data.address}
                    textName={"address"}
                    onChange={handleOnChangeLocation}
                    isMandatory={true}
                    display={
                      data.country == "" ||
                      data.country == "-" ||
                      data.country == "N/A" ||
                      data.country == "Not defined"
                    }
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextNoConfidential
                    label={"City / town"}
                    textValid={data.city.length > 4}
                    textValue={data.city}
                    textName={"city"}
                    onChange={handleOnChangeLocation}
                    isMandatory={true}
                    display={
                      data.country == "" ||
                      data.country == "-" ||
                      data.country == "N/A" ||
                      data.country == "Not defined"
                    }
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <TextNoConfidential
                    label={"ZIP/post code"}
                    textValid={data.zipCode.length > 4}
                    textValue={data.zipCode}
                    textName={"zipCode"}
                    onChange={handleOnChangeLocation}
                    isMandatory={true}
                    display={
                      data.country == "" ||
                      data.country == "-" ||
                      data.country == "N/A" ||
                      data.country == "Not defined"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </div>
  );
}
export default LocationComponent;
